import React, { FunctionComponent, useState } from 'react';
import { Button, Table } from '@vwfs-bronson/bronson-react';
import axios from 'axios';
import { getLeasingDocumentFileLink } from '../../../../../services/api/miles/central-document-handling';
import {
  DashboardSubpageDocumentsEntityType,
  DashboardSubpageDocumentsSourceType,
} from '../../DashboardSubpageDocuments/DashboardSubpageDocuments';

interface DashboardDocumentLeasingDocumentTableRowProps {
  selectedId: string;
  documentId: string;
  documentName: string;
  transactionId: string;
  sourceType: DashboardSubpageDocumentsSourceType;
  entityType: DashboardSubpageDocumentsEntityType;
}

export const DashboardDocumentLeasingDocumentTableRow: FunctionComponent<
  DashboardDocumentLeasingDocumentTableRowProps
> = ({ selectedId, documentId, documentName, transactionId, sourceType, entityType }) => {
  const [cachedFile, setCachedFile] = useState<string | null>(null);
  const [isFileDownloading, setIsFileDownloading] = useState(false);

  const downloadFileFromURL = (fileUrl: string) => {
    const hiddenElement = document.createElement('a');
    hiddenElement.href = fileUrl;
    hiddenElement.download = `${documentName?.replace('.pdf', '')}.pdf` || 'file.pdf';

    document.body.appendChild(hiddenElement);
    hiddenElement.click();
    document.body.removeChild(hiddenElement);
    setIsFileDownloading(false);
  };

  const onDownloadButton = async () => {
    setIsFileDownloading(true);

    let fileUrl: string | null = null;

    if (cachedFile) {
      downloadFileFromURL(cachedFile);
      return;
    }

    try {
      const { url } = await getLeasingDocumentFileLink(selectedId, documentId, transactionId, sourceType, entityType);
      fileUrl = url;
    } catch {
      setIsFileDownloading(false);
    }

    if (fileUrl) {
      const fileData = await await axios.get(fileUrl, { responseType: 'blob' });
      const blob = await fileData.data;
      const fileUrlPayload = window.URL.createObjectURL(blob);
      downloadFileFromURL(fileUrlPayload);
      setCachedFile(fileUrlPayload);
    }
  };

  return (
    <Table.Tr>
      <Table.Td>{documentName}</Table.Td>
      <Table.Td className="u-text-right">
        <Button
          onClick={() => {
            onDownloadButton();
          }}
          icon="semantic-download"
          link
          simple
          small
          aria-busy={isFileDownloading}
          disabled={isFileDownloading}
        />
      </Table.Td>
    </Table.Tr>
  );
};
